var map = {
	"./FORGE_FAIL.jpg": 13754,
	"./FORGE_START_BLUE.jpg": 26206,
	"./FORGE_START_GREEN.jpg": 11816,
	"./FORGE_START_PURPLE.jpg": 53094,
	"./FORGE_START_WHITE.jpg": 183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79667;